import styled from 'styled-components'
export const Wrapper = styled.div`
  .input-group-rtl {
    display: flex;
    flex-direction: row-reverse;
  }
`
